import { createContext, useContext, type ReactNode } from 'react';

import type { useNinpoCore } from '../app/hooks/useNinpoCore';

type NinpoCore = ReturnType<typeof useNinpoCore>;

const CoreContext = createContext<NinpoCore | null>(null);

export function CoreProvider({ value, children }: { value: NinpoCore; children: ReactNode }) {
  return <CoreContext.Provider value={value}>{children}</CoreContext.Provider>;
}

export function useCoreContext() {
  const context = useContext(CoreContext);
  if (!context) {
    throw new Error('useCoreContext must be used within CoreProvider');
  }
  return context;
}

/** Soft read for shared UI that may render outside CoreProvider (e.g. isolated scanner tests). */
export function useCoreContextOptional() {
  return useContext(CoreContext);
}
